// AUTH
export const LOGIN = '/auth/login';
export const DETAILS = '/auth/details';
export const CHANGE_PASSWORD = '/auth/change-password';
export const VERIFY_EMPLOYEE = '/auth/verify-employee';
export const REGISTER_EMPLOYEE = '/auth/register';
export const FIRST_LOGIN_PASSWORD = '/auth/first-login-password';

// SETTINGS
export const BANKS = '/settings/banks';
export const BRANCHES = '/settings/branches';
export const DEPARTMENTS = '/settings/departments';
export const DESIGNATIONS= '/settings/designations';
export const DOCUMENT_TYPES = '/document-types';
export const HOLIDAYS = '/holidays';
export const LEAVE_TYPES = '/settings/leave-types';
export const TERMINATION_TYPES = '/settings/termination-types';
export const ROLES = '/settings/roles';
export const PERMISSIONS = '/settings/permissions';
export const COUNTRIES = '/utilities/countries';
export const STATES = '/utilities/states';
export const COMPANY_SETTINGS = '/settings/company';
export const APPROVAL_SETTINGS = '/settings/approval';
export const EMAIL_SETTINGS = '/settings/email';
export const EMAIL_TEST = '/settings/email/test';
export const LOCALIZATION_SETTINGS = '/settings/localization';
export const SALARY_SETTINGS = '/settings/salary';
export const NOTIFICATION_SETTINGS = '/settings/notifications';
export const SMS_SETTINGS = '/settings/sms';
export const SMS_TEST = '/settings/sms/test';

// EMPLOYEES
export const EMPLOYEE = '/employees';
export const GET_EMPLOYEES = '/employees';
export const EXPORT_EMPLOYEES = '/employees/export';
export const SEARCH_EMPLOYEES = '/employees/search';
export const BIOTIME_SEARCH = '/employess/biotime/search';
export const UPDATE_BIOTIME_ID = '/employees/update-emp-id';
export const UPLOAD_EMP_DOCUMENTS = '/employees/upload-documents';

// HR/PERFORMANCE
export const LEAVES = '/leave/requests';
export const PROMOTIONS = '/hr/promotions';
export const TRANSFERS = '/hr/transfers';
export const TERMINATIONS = '/hr/terminations';
export const RESIGNATIONS = '/hr/resignations';

// ATTENDANCE REPORTS (V2)
export const ATT_DAILY = '/attendance/reports/daily';
export const ATT_FIRST_IN_LAST_OUT = '/attendance/reports/first-in-last-out';
export const ATT_TIME_CARD = '/attendance/reports/time-card';
export const ATT_SUMMARY = '/attendance/reports/summary';

// ATTENDANCE (V1 - legacy)
export const ATT_DETAILS = '/attendance/info';
export const ATT_EMPLOYEE = '/attendance/employee';
export const ATT_ADD_EXCEPTION = '/attendance/add-exception';

// LOANS
export const LOANS = '/loans';

//NOTIFICATIONS

//PAYROLL
export const PAYROLL_SALARY = '/payroll/salary';
export const PAYROLL_PAYSLIPS = '/payroll/payslips';
export const PAYROLL_PROCESS = '/payroll/process';
export const PAYROLL_SALARY_COMPONENTS = '/payroll/salary-components';

//PERFORMANCE


